import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMisFortalezasSummaryService } from "../../services/fortalezas/misFortalezas.service";

// ============================================================
// Thunks
// ============================================================

export const getMisFortalezasThunk = createAsyncThunk(
  "misFortalezas/getSummary",
  async (_, { rejectWithValue }) => {
    try {
      return await getMisFortalezasSummaryService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al cargar tus fortalezas."
      );
    }
  }
);

// ============================================================
// Slice
// ============================================================

const initialState = {
  misFortalezas: [],
  loading: false,
  error: null,
};

const misFortalezasSlice = createSlice({
  name: "misFortalezas",
  initialState,
  reducers: {
    clearMisFortalezas: (state) => {
      state.misFortalezas = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMisFortalezasThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMisFortalezasThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.misFortalezas = action.payload.mis_fortalezas || [];
      })
      .addCase(getMisFortalezasThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMisFortalezas } = misFortalezasSlice.actions;
export default misFortalezasSlice.reducer;
